module.exports = __webpack_public_path__ + "img/i_my_c_promise.b97230a9.svg";